var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-6" },
    [
      _vm.aiSummaryLoading
        ? _c("div", { staticClass: "flex flex-col items-center mt-4" }, [
            _vm._m(0)
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("VueLoading", {
        attrs: { active: _vm.aiSummaryLoading, "is-full-page": false },
        on: {
          "update:active": function($event) {
            _vm.aiSummaryLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.aiInsights && !_vm.aiSummaryLoading
        ? _c(
            "div",
            {
              staticClass:
                "bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg p-6 border border-gray-200"
            },
            [
              _c("div", { staticClass: "flex items-center mb-4" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-9 h-9 bg-transparent rounded-lg flex items-center justify-center mr-3"
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "w-6 h-6 text-white",
                        attrs: {
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d:
                              "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("h3", { staticClass: "text-lg font-semibold text-white" }, [
                  _vm._v(_vm._s(_vm.aiInsights.title))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-white mb-6 leading-relaxed" }, [
                _vm._v(_vm._s(_vm.aiInsights.summary))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" },
                _vm._l(_vm.aiInsights.metrics, function(metric, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: [
                        "rounded-lg p-4 border border-gray-100 shadow-sm",
                        index === 0
                          ? "bg-gradient-to-r from-blue-500 to-blue-600"
                          : "",
                        index === 1
                          ? "bg-gradient-to-r from-blue-600 to-purple-500"
                          : "",
                        index === 2
                          ? "bg-gradient-to-r from-purple-500 to-purple-600"
                          : ""
                      ]
                    },
                    [
                      _c("div", { staticClass: "flex items-start" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "w-10 h-10 bg-transparent rounded-lg flex items-center justify-center mr-3 flex-shrink-0"
                          },
                          [
                            metric.title.includes("Cost")
                              ? _c(
                                  "svg",
                                  {
                                    staticClass: "w-5 h-5 text-white",
                                    attrs: {
                                      fill: "none",
                                      stroke: "currentColor",
                                      viewBox: "0 0 24 24"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                                      }
                                    })
                                  ]
                                )
                              : metric.title.includes("Deployment")
                              ? _c(
                                  "svg",
                                  {
                                    staticClass: "w-5 h-5 text-white",
                                    attrs: {
                                      fill: "none",
                                      stroke: "currentColor",
                                      viewBox: "0 0 24 24"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M13 10V3L4 14h7v7l9-11h-7z"
                                      }
                                    })
                                  ]
                                )
                              : metric.title.includes("Reliability") ||
                                metric.title.includes("System")
                              ? _c(
                                  "svg",
                                  {
                                    staticClass: "w-5 h-5 text-white",
                                    attrs: {
                                      fill: "none",
                                      stroke: "currentColor",
                                      viewBox: "0 0 24 24"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d:
                                          "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                      }
                                    })
                                  ]
                                )
                              : _c(
                                  "svg",
                                  {
                                    staticClass: "w-5 h-5 text-white",
                                    attrs: {
                                      fill: "none",
                                      stroke: "currentColor",
                                      viewBox: "0 0 24 24"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d:
                                          "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                                      }
                                    })
                                  ]
                                )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex-1" }, [
                          _c(
                            "h4",
                            { staticClass: "font-medium text-white text-sm" },
                            [_vm._v(_vm._s(metric.title))]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "font-semibold text-white mt-1" },
                            [_vm._v(_vm._s(metric.value))]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "text-xs text-gray-100 mt-1" },
                            [_vm._v(_vm._s(metric.description))]
                          )
                        ])
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex-col sm:flex-row gap-3 mb-6" },
                [
                  _vm.zoomEnabled
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors font-medium",
                          on: {
                            click: function($event) {
                              return _vm.$emit("investigate-points")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.flowEvents.length > 0
                                  ? "Refresh Detailed Analysis"
                                  : "View Detailed Analysis"
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              (_vm.flowEvents && _vm.flowEvents.length > 0) ||
              _vm.detailedAnalysisLoading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg p-6 mt-6"
                    },
                    [
                      _vm.detailedAnalysisLoading
                        ? _c(
                            "div",
                            { staticClass: "flex flex-col items-center mt-4" },
                            [_vm._m(1)]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.detailedAnalysisLoading
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "flex items-center mb-6" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "w-6 h-6 bg-transparent rounded-lg flex items-center justify-center mr-3"
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "w-4 h-4 text-white",
                                        attrs: {
                                          fill: "none",
                                          stroke: "currentColor",
                                          viewBox: "0 0 24 24"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d:
                                              "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "h4",
                                  {
                                    staticClass:
                                      "text-md font-semibold text-white"
                                  },
                                  [_vm._v("Detailed Event Analysis")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "space-y-4 mb-6" },
                              _vm._l(_vm.flowEvents, function(event, index) {
                                return _c(
                                  "div",
                                  {
                                    key: event.id,
                                    staticClass:
                                      "relative flex items-start pb-4",
                                    class: {
                                      "border-b border-gray-100":
                                        index < _vm.flowEvents.length - 1
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center mr-4 bg-transparent"
                                      },
                                      [
                                        event.type === "deployment"
                                          ? _c(
                                              "svg",
                                              {
                                                staticClass:
                                                  "w-5 h-5 text-white",
                                                attrs: {
                                                  fill: "none",
                                                  stroke: "currentColor",
                                                  viewBox: "0 0 24 24"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d:
                                                      "M13 10V3L4 14h7v7l9-11h-7z"
                                                  }
                                                })
                                              ]
                                            )
                                          : event.type === "alert"
                                          ? _c(
                                              "svg",
                                              {
                                                staticClass:
                                                  "w-5 h-5 text-white",
                                                attrs: {
                                                  fill: "none",
                                                  stroke: "currentColor",
                                                  viewBox: "0 0 24 24"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d:
                                                      "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.864-.833-2.634 0L4.18 16.5c-.77.833.192 2.5 1.732 2.5z"
                                                  }
                                                })
                                              ]
                                            )
                                          : event.type === "cost"
                                          ? _c(
                                              "svg",
                                              {
                                                staticClass:
                                                  "w-7 h-7 text-white",
                                                attrs: {
                                                  fill: "none",
                                                  stroke: "currentColor",
                                                  viewBox: "0 0 24 24"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "1.5",
                                                    d:
                                                      "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
                                                  }
                                                })
                                              ]
                                            )
                                          : _c(
                                              "svg",
                                              {
                                                staticClass:
                                                  "w-5 h-5 text-white",
                                                attrs: {
                                                  fill: "none",
                                                  stroke: "currentColor",
                                                  viewBox: "0 0 24 24"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d:
                                                      "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                                  }
                                                })
                                              ]
                                            )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex-1 min-w-0" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center justify-between mb-2"
                                          },
                                          [
                                            _c(
                                              "h5",
                                              {
                                                staticClass:
                                                  "text-sm font-semibold truncate px-2 py-1 rounded",
                                                class: {
                                                  "text-green-600 bg-green-100":
                                                    event.type === "deployment",
                                                  "text-red-600 bg-red-100":
                                                    event.type === "alert",
                                                  "text-blue-600 bg-blue-100":
                                                    event.type === "cost",
                                                  "text-gray-600 bg-gray-100": ![
                                                    "deployment",
                                                    "alert",
                                                    "cost"
                                                  ].includes(event.type)
                                                }
                                              },
                                              [_vm._v(_vm._s(event.label))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-xs text-gray-500 font-medium px-2 py-1 bg-gray-100 rounded-full"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(event.date) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        event.description
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "text-sm text-white leading-relaxed"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(event.description) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "inline-flex items-center px-2 py-1 mt-2 text-xs font-medium rounded-full",
                                            class: {
                                              "bg-green-100 text-green-800":
                                                event.type === "deployment",
                                              "bg-red-100 text-red-800":
                                                event.type === "alert",
                                              "bg-blue-100 text-blue-800":
                                                event.type === "cost",
                                              "bg-gray-100 text-gray-800": ![
                                                "deployment",
                                                "alert",
                                                "cost"
                                              ].includes(event.type)
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  event.type
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                    event.type.slice(1)
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4 border-t border-gray-100"
                              },
                              [
                                _c("div", { staticClass: "text-center" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-3xl font-bold text-green-600 bg-green-100 rounded-lg p-3 max-w-xs mx-auto"
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.flowEvents.filter(function(e) {
                                              return e.type === "deployment"
                                            }).length
                                          ) +
                                          "\n              "
                                      ),
                                      _c("div", { staticClass: "text-lg" }, [
                                        _vm._v("Deployments")
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "text-center" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-3xl font-bold text-red-600 bg-red-100 rounded-lg p-3 max-w-xs mx-auto"
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.flowEvents.filter(function(e) {
                                              return e.type === "alert"
                                            }).length
                                          ) +
                                          "\n              "
                                      ),
                                      _c("div", { staticClass: "text-lg" }, [
                                        _vm._v("Alerts")
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "text-center" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-3xl font-bold text-blue-600 bg-blue-100 rounded-lg p-3 max-w-xs mx-auto"
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.flowEvents.filter(function(e) {
                                              return e.type === "cost"
                                            }).length
                                          ) +
                                          "\n              "
                                      ),
                                      _c("div", { staticClass: "text-lg" }, [
                                        _vm._v("Cost Events")
                                      ])
                                    ]
                                  )
                                ])
                              ]
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.aiInsightsError && !_vm.aiSummaryLoading
        ? _c(
            "div",
            { staticClass: "bg-red-50 rounded-lg p-4 border border-red-200" },
            [
              _c("div", { staticClass: "flex items-center mb-2" }, [
                _c(
                  "svg",
                  {
                    staticClass: "w-5 h-5 text-red-600 mr-2",
                    attrs: {
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("h3", { staticClass: "text-sm font-medium text-red-800" }, [
                  _vm._v("Analysis Error")
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-sm text-red-700" }, [
                _vm._v(_vm._s(_vm.aiInsightsError))
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "mt-3 px-3 py-1 bg-red-100 text-red-800 rounded text-sm hover:bg-red-200 transition-colors",
                  on: {
                    click: function($event) {
                      return _vm.$emit("retry-analysis")
                    }
                  }
                },
                [_vm._v("\n      Retry Analysis\n    ")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.aiSummary && !_vm.aiSummaryLoading && !_vm.aiInsights
        ? _c(
            "div",
            { staticClass: "bg-gray-50 rounded-lg p-4 border border-gray-200" },
            [
              _c(
                "h3",
                { staticClass: "text-lg font-medium text-gray-700 mb-2" },
                [_vm._v("AI-Generated Summary")]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "text-sm text-gray-900" }, [
                _vm._v(_vm._s(_vm.aiSummary))
              ]),
              _vm._v(" "),
              _vm.zoomEnabled
                ? _c(
                    "button",
                    {
                      staticClass:
                        "mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition",
                      on: {
                        click: function($event) {
                          return _vm.$emit("investigate-points")
                        }
                      }
                    },
                    [_vm._v("\n      Investigate\n    ")]
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "text-black text-lg" }, [
      _vm._v("\n      Retrieving response, this may take a moment\n      "),
      _c("span", { staticClass: "dots-animation" }, [
        _c("span", { staticClass: "dot" }, [_vm._v(".")]),
        _vm._v(" "),
        _c("span", { staticClass: "dot" }, [_vm._v(".")]),
        _vm._v(" "),
        _c("span", { staticClass: "dot" }, [_vm._v(".")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "text-white text-lg" }, [
      _vm._v(
        "\n          Retrieving detailed response, this may take a moment\n          "
      ),
      _c("span", { staticClass: "dots-animation" }, [
        _c("span", { staticClass: "dot" }, [_vm._v(".")]),
        _vm._v(" "),
        _c("span", { staticClass: "dot" }, [_vm._v(".")]),
        _vm._v(" "),
        _c("span", { staticClass: "dot" }, [_vm._v(".")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72cb155e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72cb155e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/AICards/TimeSeriesCard/CombinedMetrics/CombinedMetricsAnalysis.vue
// module id = null
// module chunks = 